<template>
  <div class="continer">
    <ul>
      <li v-for="(item,index) in avatarList" :key="index">
        <img :src="item.picture" alt="">
        <h5>{{item.name}}</h5>
        <p>{{item.content}}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import {experts_query} from '../../api/user/index'
import {ERR_OK} from '../../api/common/config'
export default {
  data() {
    return {
      avatarList:[]
    }
  },
  mounted() {
    this._experts_query()
  },
  methods: {
    _experts_query () {
      experts_query().then((res)=>{
        if(res.data.isok === ERR_OK) {
          this.avatarList = res.data.data
          // console.log(this.avatarList)
        }
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
.continer 
  width 100%
  color #333
  // background #F5F5F5
  ul 
    padding 30px
    box-sizing border-box
    display flex
    flex-wrap wrap
    li 
      margin-right 30px
      img 
        width 172px
        height 172px
        border-radius 10px
      h5,p
        font-size 12px
        color #333333
      h5 
        margin 10px 0
        text-align center
</style>
